import f3tch from 'f3tch';

import profile from '../../api/profiles/noData.profile.api';

export default (ticketId, noteId) =>
  f3tch(`/crm/tickets/${ticketId}/notes/${noteId}/`)
    .profile(profile())
    .delete();
